export var MAXIMUM_WINDOW_HEIGHT_FOR_MODAL_CALENDAR = 850;